import React, { useCallback } from "react";

import PropTypes from "prop-types";

import { toBasicCodeOptions } from "components/flowable/ClassificationCodes/helpers";
import CodeTemplate from "components/flowable/ClassificationCodes/internal/CodeTemplate";
import { useDictionary } from "hooks";


const FORCode = ({ forMinimum, forMaximum, limitToFourDigits, ...rest }) => {
	const dictionary = useDictionary("classificationCodes.for");

	const toCodeOptions = useCallback(
		response => toBasicCodeOptions(response, limitToFourDigits),
		[ limitToFourDigits ],
	);

	return (
		<CodeTemplate
			codeType="for"
			toCodeOptions={toCodeOptions}
			dictionary={dictionary}
			maximumNumberOfCodes={forMaximum}
			minimumNumberOfCodes={forMinimum}
			{...rest}
		/>
	);
};


FORCode.defaultProps = {
	forMinimum: 1,
	forMaximum: 6,
	includePercentage: true,
	limitToFourDigits: false,
};

FORCode.propTypes = {
	forMinimum: PropTypes.number,
	forMaximum: PropTypes.number,
	includePercentage: PropTypes.bool,
	limitToFourDigits: PropTypes.bool,
	value: PropTypes.any,
	onChange: PropTypes.func.isRequired,
	enabled: PropTypes.bool.isRequired,
};

export default FORCode;
